<template>
  <div class="Title"> 
    <div ref="title">My story is my</div>
    <div ref="indice" class="Title__indice">{{ indice }}</div>
  </div> 
</template>

<script>

import gsap from "gsap"

export default {

  name: 'Title',
  props: ['indice'],
  mounted() {

    if(this.$root.route.to.params.section == 'story')
      gsap.from(this.$refs.title, { 
      duration: .5,  
      opacity: 0,
      ease: 'none',
      delay: .5, 
    })
    else 
      gsap.from(this.$refs.indice, { 
        duration: .5,  
        opacity: 0,
        ease: 'none',
        delay: .25, 
      })

  },

}
</script>

<style lang="stylus">
@import '~@/config/Settings'

.Title
  position relative
  text-align center
  font-family SpaceGrotesk
  font-size 1.88em
  width 100%
  height 22%
  display flex 
  justify-content center
  align-items flex-end

  &__indice
    position absolute
    text-transform capitalize
    font-weight 900

    bottom -44px

</style>


